export default __webpack_public_path__ + "static/media/paint-roller.47a02151.svg";